const supplierQuotation = {
    status: "状态",
    productCode: "商品编码",
    productName: "商品名称",
    productModel: "商品型号",
    productCount: "商品数量",
    mrd: "预计交货时间",
    deadline: "最晚提交时间",
    mpq: "合同最小包装",
    curMpq: "单次最小包装",
    days: "合同供货周期",
    curDays: "单次供货周期",
    price: "合同价",
    curPrice: "单次报价",
    curTotalPrice: "单次总价",
    submitTimer: "提交倒计时",
    operation: "操作",
    handlePrice: "报价",
    priceInfo: "报价信息",
    rejected: "已拒绝",
    confirmQuotate:'确定报价么？',
    confirmQuotateTip:'这将对该商品提交报价',
};

export default supplierQuotation;